import { api } from '@cwd/lib/main';

export interface ServiceLevelPriceTier {
    ServiceSubscriptionTier: {
        Name: string;
        Version: string;
    };
    ServiceLevels: ServiceLevelPriceRow[];
}

export interface ServiceLevelPriceRow {
    ServiceLevel: {
        Name: string;
    };
    Currencies: ServiceLevelPriceCurrency[];
}

export interface ServiceLevelPriceCurrency {
    MonthlyPrice: number;
    Currency: {
        CurrencyCode: string;
    };
}

export async function getServiceLevelPrices(): Promise<ServiceLevelPriceTier[]> {
    return api.get('/ServiceLevelPrices');
}
